module.exports = __webpack_public_path__ + "ececbdfce5ad6c7380b8c96159dd8a4d.pdf";